import * as React from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import './progress-bar.scss'
import { isMobile } from 'react-device-detect';

export default function progressBar({step}:any) {
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          return 0;
        }
        const diff = Math.random() * 10;
        return Math.min(oldProgress + diff, 100);
      });
    }, 500);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Box className={isMobile ? "progress-bar-mobile" : "progress-bar"} sx={{ width: '100%' }}>
      <p className='step-title'>{step?.title}</p>
      <LinearProgress variant="determinate" value={step?.progress} />
    </Box>
  );
}